import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  errorMessage: {
    // textAlign: "center"
  },
 
}));
